import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

const ScrollableTableContainer = styled.div`
    position: relative;
    overflow: auto;
    width: 100%;
    max-width: 94.5rem;
    max-height: ${p => p.maxHeight || "calc(100vh - 18rem)"};
    min-height: ${p => p.minHeight || "auto"};
    box-sizing: border-box;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    box-shadow: ${portalColors.shadow};
    --portal-table-row-height: 3.4rem;
    animation: portal-table-enter 0.22s ease both;

    @keyframes portal-table-enter {
        from {
            opacity: 0;
            transform: translateY(6px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    ::-webkit-scrollbar {
        display: block;
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${portalColors.borderStrong};
        border-radius: 6px;
        border-right: none;
        border-left: none;
    }

    ::-webkit-scrollbar-track-piece:end {
        background-color: ${portalColors.surfaceTertiary};
        border-radius: 6px;
        margin-bottom: 30px;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceTertiary};
        border-radius: 6px;
    }

    @media (max-width: 760px) {
        max-height: none;
        border-radius: 14px;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export default ScrollableTableContainer;
